import { Box, Typography, Button } from "@mui/material";
import ButtonBlue from "../common/ButtonBlue";
import { ROUTE_BROWSE_JOBS_NEW, ROUTE_PROFILE_CONSIST } from "../../constants/routes";
import { useNavigate } from "react-router-dom";

const GreatStart = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: "#FE845A",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "30px",
        color: "#ffffff",
        fontFamily: "'Poppins', sans-serif",
        boxSizing: "border-box",
      }}
    >
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/d58bcbd8443743266ea63a1228b43266d03a87cc67fa05eb2cf1fd9a4bc183e1?apiKey=d94ace7eb9234970be6d52e95c888888&"
        alt=""
        style={{ width: "109px", height: "58px", marginBottom: "20px", top: "10px" }}
      />
      <Typography variant="h4" style={{ marginBottom: "10px", fontWeight: "600", fontSize: "30px", color: "#ffffff" }}>
        Great Start!
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: "500", fontSize: "18px", color: "#ffffff", textAlign: "center" }}>
        What would you like to do next?
      </Typography>
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/9a279926f5968dd284eadea876740cae4d9b2d5f151b00029f0d8a7926ba9262?apiKey=d94ace7eb9234970be6d52e95c888888&"
        alt=""
        style={{ borderRadius: "50%", width: "195px", height: "195px", marginBottom: "20px", marginTop: "20px" }}
      />
      <ButtonBlue title="Continue with your profile" onClick={() => navigate(ROUTE_PROFILE_CONSIST)} />

      <Button
        onClick={() => navigate(ROUTE_BROWSE_JOBS_NEW)}
        sx={{
          color: "#756DE9",
          backgroundColor: "#ffffff",
          borderRadius: "99px",
          fontSize: "16px",
          fontWeight: "600",
          textTransform: "capitalize",
          width: "100%",
          marginTop: "-5px !important",
          "&:hover": {
            backgroundColor: "#ffffff",
          },
          padding: "15px 50px",
        }}
        variant="contained"
        className="w-100 mt-3 btn-pad"
        size="small"
      >
        Browse Jobs
      </Button>
    </Box>
  );
};

export default GreatStart;
